/** Drag data of a label row in the board label manager. */
export const boardLabelData = (boardId: string, labelId: string) => ({
  type: 'board-label',
  boardId,
  labelId,
});

export function isBoardLabel(
  data: Record<string | symbol, unknown>,
): data is Record<string | symbol, unknown> & ReturnType<typeof boardLabelData> {
  return (
    data.type === 'board-label' &&
    typeof data.boardId === 'string' &&
    typeof data.labelId === 'string'
  );
}
